// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const suicune: PokeData = {
  "id": 245,
  "name": "suicune",
  "height": 20,
  "weight": 1870,
  "base_experience": 261,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "gust",
    "leer",
    "bite",
    "roar",
    "mist",
    "water-gun",
    "hydro-pump",
    "surf",
    "blizzard",
    "bubble-beam",
    "aurora-beam",
    "rain-dance",
    "crunch",
    "mirror-coat",
    "extreme-speed",
    "extrasensory",
    "sheer-cold",
    "calm-mind",
    "water-pulse",
    "tailwind",
    "ice-fang"
  ],
  "moves": [
    "gust",
    "leer",
    "bite",
    "hydro-pump",
    "blizzard",
    "bubble-beam",
    "rain-dance",
    "crunch",
    "sheer-cold",
    "calm-mind",
    "tailwind",
    "ice-fang",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 125,
    "item": null,
    "species": [
      {
        "name": "suicune",
        "order": 270,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 152,
    "speed": 120,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
